<template>
    <div class="form-group">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label + (error && errorMessage ? ` ${$t('dash-{s}', {'s': errorMessage})}` : '') }}</slot>
        </label>
        <input
            :id="id.ID()"
            type="time"
            :value="value"
            @input="$emit('input', $event.target.value)"
            class="form-control"
            :class="{ 'is-invalid' : error }"
        >
    </div>
</template>

<script>
import id from "src/modules/uuid.js"

export default {
    props: {
        value: String,
        label: {
            type: String,
            required: true,
        },
        srOnly: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            id: new id()
        }
    }
}
</script>